import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { ZodTypeAny } from 'zod';
import { getPsSaveValidationMessage } from './getPsSaveValidationMessage';

/** Explains why the PS Save button is disabled. Isolated so per-keystroke re-renders stay local. */
export const PsSaveValidationMessage = ({ schema }: { schema: ZodTypeAny }) => {
  const { control } = useFormContext();
  const values = useWatch({ control });

  const message = useMemo(() => {
    const result = schema.safeParse(values);
    return result.success ? null : getPsSaveValidationMessage(result.error.issues, values);
  }, [schema, values]);

  if (!message) return null;

  return <p className="text-sm text-destructive text-right">{message}</p>;
};
